import { View } from '@adobe/react-spectrum';
import { useDeviceDetection } from '../../../../hooks/UseDeviceDetection';
import { useViewInfo } from '../../../../hooks/UseViewInfo';

export interface ProjectActivitiesLayoutProps {
  showMobileDetailView: boolean;
  mobileListView: React.ReactNode;
  mobileDetailView: React.ReactNode;
  desktopLayout: React.ReactNode;
}

/**
 * ProjectActivitiesLayout - Routes between mobile and desktop layouts based on device.
 */
export function ProjectActivitiesLayout({
  showMobileDetailView,
  mobileListView,
  mobileDetailView,
  desktopLayout,
}: ProjectActivitiesLayoutProps) {
  const { isMobile } = useViewInfo();
  const deviceInfo = useDeviceDetection(isMobile);
  const shouldUseDesktopLayout =
    !deviceInfo.shouldUseMobileLayout() ||
    ((deviceInfo.isTablet || deviceInfo.isIPad) && deviceInfo.orientation === 'landscape');

  if (shouldUseDesktopLayout) {
    return <>{desktopLayout}</>;
  }

  return (
    <>
      {!showMobileDetailView ? mobileListView : mobileDetailView}
    </>
  );
}
